module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./InformationView.js"));
	}, "FindingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FindingView!./src/pages/Learn/Information/InformationView.js
// module id = 1772
// module chunks = 418